import { Controller } from '@hotwired/stimulus';

export default class extends Controller {
  static targets = ['applyModal', 'isApplicableCheckbox', 'hasApplicationFormSection', 'hasApplicationFormCheckbox'];
  static values = {
    meetId: Number,
    meetApplyId: Number,
    isSuspendUser: Boolean,
    isLoggedUser: Boolean,
    isGroupUser: Boolean,
  };

  hasApplicationFormSectionTargetConnected() {
    this.toggleApplicationFormSection();
  }

  toggleApplicationFormSection() {
    const isApplicable = this.isApplicableCheckboxTarget.checked;
    if (isApplicable) {
      this.hasApplicationFormSectionTarget.classList.remove('hidden');
    } else {
      this.hasApplicationFormSectionTarget.classList.add('hidden');
      this.hasApplicationFormCheckboxTarget.checked = false;
    }
  }

  openApplyModal() {
    if (!this.isLoggedUserValue) {
      location.href = '/denied/anonymous';
      return;
    }
    if (this.isSuspendUserValue) {
      location.href = '/denied/suspend';
      return;
    }
    if (!this.isGroupUserValue) {
      location.href = '/denied/guest';
      return;
    }
    document.body.classList.add('overflow-hidden');
    this.applyModalTarget.classList.remove('hidden');
  }

  closeApplyModal() {
    document.body.classList.remove('overflow-hidden');
    this.applyModalTarget.classList.add('hidden');
  }
}
